import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { IFilterCategory } from '../../models/i-filter-category';
import { ngHelper, UiContextService } from '@cakeiteasy/web-utils';
import first from 'lodash/first';
import find from 'lodash/find';
import trim from 'lodash/trim';

@Component({
  standalone: false,
  selector: 'categories-selector',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './categories-selector.component.html',
  styleUrls: ['./categories-selector.component.scss']
})
export class CategoriesSelectorComponent implements OnChanges {
  @Input() categories: IFilterCategory[];
  @Input() activeCategoryId: number;
  @Input() maxCategoriesToShow = 0;
  @Input() urlPrefix = '';
  @Input() containerOffsetTop: number;
  @Output() onSelect = new EventEmitter<IFilterCategory>();

  public activeCategory: IFilterCategory;

  public linkCategories: IFilterCategory[];

  public dropdownCategories: IFilterCategory[];
  public selectedDropdownCategory: IFilterCategory;

  @HostListener('window:resize')
  handleResize() {
    if (this.categories) {
      this._initDropdownCategories(this.categories);
    }
  }

  constructor(public uiContext: UiContextService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'categories', (categories) => {
      if (!categories) {
        return;
      }

      if (!this.activeCategoryId) {
        const category = first(this.categories);
        this.activeCategoryId = category.id;
      } else {
        this.activeCategory = find(this.categories, (c) => c.id === this.activeCategoryId);
      }

      this._initDropdownCategories(categories);

      if (this.selectedDropdownCategory) {
        this._updateSelectedDropdownCategory(this.selectedDropdownCategory.id);
      }
    });

    ngHelper.ifChanged(changes, 'activeCategoryId', (newCategoryId) => {
      if (newCategoryId && this.categories) {
        this.activeCategory = find(this.categories, (c) => c.id === newCategoryId);
        this._updateSelectedDropdownCategory(newCategoryId);
      }
    });

    ngHelper.ifChanged(changes, 'maxCategoriesToShow', () => {
      this._initDropdownCategories(this.categories);
    });

    ngHelper.ifChanged(changes, 'urlPrefix', (prefix) => {
      if (prefix && prefix.length) {
        this.urlPrefix = trim(this.urlPrefix, '/') + '/';
      }
    });
  }

  public selectCategory(category: IFilterCategory) {
    this.selectedDropdownCategory = null;
    this._selectCategory(category);
  }

  public dropdownSelectCategory(category: IFilterCategory) {
    this.selectedDropdownCategory = category;
    this._selectCategory(category);
  }

  private _selectCategory(category: IFilterCategory) {
    if (this.activeCategoryId === category.id) {
      return;
    }

    this.activeCategory = category;
    this.activeCategoryId = category.id;
    this.onSelect.emit(category);
  }

  private _initDropdownCategories(categories) {
    if (this.uiContext.isXs()) {
      this.dropdownCategories = categories;
    } else if (this.maxCategoriesToShow > 0 && categories.length > (this.maxCategoriesToShow + 1)) {
      this.linkCategories = categories.slice(0, this.maxCategoriesToShow);
      this.dropdownCategories = categories.slice(this.maxCategoriesToShow, this.categories.length);
      this.selectedDropdownCategory = this.dropdownCategories.find((c) => c.id === this.activeCategoryId) || null;
    } else {
      this.linkCategories = categories;
      this.dropdownCategories = [];
    }
  }

  private _updateSelectedDropdownCategory(categoryId: number) {
    this.selectedDropdownCategory = this.dropdownCategories
      .find((c) => c.id === categoryId);
  }

}
